import { getInitialLetters } from "utils/constants";
import styles from "./styles.module.scss";

export const NameInitials = ({ bgColor, color, name, size }) => {
  const initials = getInitialLetters(name);
  return (
    <div
      className={styles.container}
      style={{ height: `${size}px`, width: `${size}px` }}
    >
      {initials}
    </div>
  );
};
